import { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { patchRequest } from "../services/apiMethods";
import toast from "react-hot-toast";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [localLoading, setLocalLoading] = useState(false);
  const [searchParams] = useSearchParams();

  // get token from query string
  const token = searchParams.get("token");

  useEffect(() => {
    if (token) {
      sessionStorage.setItem("forgotToken", token);
    }
  }, [token]);

  const { mutate, isLoading } = useMutation({
    mutationFn: (data) => patchRequest(`/user/resetPassword`, data), // ✅ API endpoint for reset
    onMutate: () => setLocalLoading(true),
    onSuccess: (data) => {
      toast.success(`${data?.message || "Password updated successfully!"}`, {
        iconTheme: {
          primary: "#337FE0",
          secondary: "#FFFAEE",
        },
      });
      navigate("/success");
       sessionStorage.removeItem('forgotToken') ;
    // If the token exists, add it to the headers
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || "Failed to reset password");
      console.error("Error during API call:", error);
    },
    onSettled: () => setLocalLoading(false),
  });

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm password is required"),
    }),
    validateOnBlur: false,
    onSubmit: () => {}, // prevent default
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    formik.setTouched({ password: true, confirmPassword: true });
    const errors = await formik.validateForm();

    if (Object.keys(errors).length === 0) {
      mutate({
         role:"user",
        password: formik.values.password,
      });
    }
  };

  return (
    <section className="commn-bg-set">
      <div className="card-center-set">
        <div className="commn-card-theme">
          <img
            className="side-logo-set"
            src={require("../Assets/images/logo-main.png")}
            alt="Logo"
          />
          <h2>Set New Password</h2>
          <p>Enter your new password below</p>

          <div className="register-data">
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="password">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  placeholder="Enter new password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                />
                {formik.touched.password && formik.errors.password && (
                  <div style={{ color: "#dc3545", fontSize: "14px", marginTop: "4px" }}>
                    {formik.errors.password}
                  </div>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="confirmPassword">
                <Form.Label>Confirm New Password</Form.Label>
                <Form.Control
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm new password"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                />
                {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                  <div style={{ color: "#dc3545", fontSize: "14px", marginTop: "4px" }}>
                    {formik.errors.confirmPassword}
                  </div>
                )}
              </Form.Group>


              <Button
                variant="primary"
                type="submit"
                disabled={isLoading || localLoading}
              >
                {localLoading ? "Saving..." : "Set Password"}
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </section>
  );
}
